export const formalityOptions = [
    { key: "default", label: "Automatic" },
    { key: "prefer_more", label: "Formal tone" },
    { key: "prefer_less", label: "Informal tone" },
] as const;

export const preferredHigherSpecificityLocales: { [key: string]: string } = {
    EN: "EN-US",
    ZH: "ZH-HANS",
};

export const preferredSameSpecificityLocales: { [key: string]: string } = {
    "EN-EU": "EN-GB",
};

export const swrKeys = {
    deeplSourceLocales: "deeplSourceLocales",
    deeplTargetLocales: "deeplTargetLocales",
    deeplUsage: "deeplUsage",
    deeplGlossaries: "deeplGlossaries",
    deeplGlossary: "deeplGlossary",
    deeplGlossaryLocales: "deeplGlossaryLocales",
};

export const glossaryLimits: { [key: string]: number } = {
    free: 1,
    pro: 2000,
};
